import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const CustomTypography = withStyles({
  root: {}
})(Typography)

export const CenteredCustomTypography = withStyles({
  root: {
    textAlign: 'center'
  }
})(CustomTypography)

export const BoldCenteredCustomTypography = withStyles({
  root: {
    fontWeight: 'bold'
  }
})(CenteredCustomTypography)

export default CustomTypography
